<template>
  <div class="plan-accordion-section critical-component-clear">
    <div class="plan-accordion-section__container">
      <accordion-snippet
        v-show="panels"
        block-class="accordion-section"
        heading-type="span"
        content-modifier-classes="
            text-mobile-paragraph-m-regular
            text-desktop-paragraph-m-regular
          "
        heading-modifier-classes="
            text-mobile-headlines-h4
            text-desktop-headlines-h4
          "
        :panel-data="panels"
        :active-panels="activePanels"
      />
    </div>
  </div>
</template>

<script>
/**
 * Vue: Plan Accordion (plan-accordion)
 * -----------------------------------------------------------------------------
 * Expandable section to display basic information about a plan and a free text.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 * @param {String} liquid.sectionTitle - Section setting title.
 * @param {String} liquid.sectionSubtitle - Section setting subtitle.
 * @param {Object} panels - Panel data.
 * @param {String} activePanels - activePanels data.
 *
 */
import AccordionSnippet from '~async/accordion-snippet/accordion-snippet';

export default {
  name: 'PlanAccordion',

  components: {
    AccordionSnippet,
  },

  props: {
    panels: {
      type: Object,
      default: () => ({
        content: '',
        title: '',
      }),
    },
    activePanels: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
@import './plan-accordion';
</style>
